module.exports = __webpack_public_path__ + "static/zavetiPopUp-dc8c8d0a4832929fd88703f2d55547f2.png";